/**
 * Created by zhangrp on 2018/3/26.
 */
import api from './index'

let exports = {};
//
//==========================平台公告==========================

// 根据id查询平台公告
exports.getPlatNoticeById = function (data, callback) {
    api.post('/merchtOper/plat/notice/get/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取公告中心列表
exports.getPlatNoticesListByFilter = function (data, callback) {
    api.post('/merchtOper/plat/notice/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};


//==========================平台新闻==========================

// 根据id查询平台新闻
exports.getPlatNewsById = function (data, callback) {
    api.post('/merchtOper/plat/news/get/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 平台新闻列表
exports.getNewsListByFilter = function (data, callback) {
    api.post('/merchtOper/plat/news/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/merchtOper.js
// module id = 74
// module chunks = 1